var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2094 6.43121C16.5996 5.09779 14.2085 0.749588 8.99981 0.749588C3.79113 0.749588 1.4 5.09779 0.79024 6.43121C0.708386 6.60991 0.666016 6.80415 0.666016 7.00069C0.666016 7.19724 0.708386 7.39148 0.79024 7.57018C1.4 8.90221 3.79113 13.2504 8.99981 13.2504C14.2085 13.2504 16.5996 8.90221 17.2094 7.56879C17.2911 7.39029 17.3334 7.1963 17.3334 7C17.3334 6.8037 17.2911 6.6097 17.2094 6.43121ZM8.99981 11.8614C4.61966 11.8614 2.57577 8.1348 2.05491 7.00764C2.57577 5.8652 4.61966 2.13857 8.99981 2.13857C13.3695 2.13857 15.4141 5.84923 15.9447 7C15.4141 8.15077 13.3695 11.8614 8.99981 11.8614Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.9998 3.52777C8.31301 3.52777 7.64165 3.73143 7.07061 4.11298C6.49956 4.49454 6.05449 5.03686 5.79167 5.67137C5.52885 6.30588 5.46008 7.00407 5.59407 7.67766C5.72805 8.35125 6.05877 8.96998 6.5444 9.45562C7.03003 9.94125 7.64877 10.272 8.32235 10.406C8.99594 10.5399 9.69414 10.4712 10.3286 10.2083C10.9632 9.94553 11.5055 9.50045 11.887 8.92941C12.2686 8.35837 12.4722 7.68701 12.4722 7.00022C12.4711 6.07961 12.1049 5.19702 11.454 4.54605C10.803 3.89507 9.92041 3.52887 8.9998 3.52777ZM8.9998 9.08369C8.58772 9.08369 8.18491 8.9615 7.84228 8.73256C7.49966 8.50363 7.23261 8.17824 7.07492 7.79753C6.91723 7.41683 6.87597 6.99791 6.95636 6.59376C7.03675 6.1896 7.23518 5.81836 7.52656 5.52698C7.81794 5.23561 8.18918 5.03717 8.59333 4.95678C8.99749 4.87639 9.4164 4.91765 9.79711 5.07535C10.1778 5.23304 10.5032 5.50008 10.7321 5.84271C10.9611 6.18533 11.0833 6.58815 11.0833 7.00022C11.0833 7.55279 10.8638 8.08273 10.473 8.47346C10.0823 8.86418 9.55237 9.08369 8.9998 9.08369Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.478cb0d46d29903e1d2cbf674f182726.svg";
export { ForwardRef as ReactComponent };